$(document).ready(function(){

  $('.hamburger').on('click', function() {
    $('.hamburger').toggleClass('hamburger_active');
    $('.menu').toggleClass('menu_active');
  });

});